// extracted by mini-css-extract-plugin
export default {"profile-page":"ProfilePage_profile-page__xJsCO","loader":"ProfilePage_loader__spbLo","overlay":"ProfilePage_overlay__uFXTg"};